var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnderDevelopment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.975,
    height: 24,
    viewBox: "0 0 23.975 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "under_development",
    "data-name": "under development",
    transform: "translate(-2.05 -2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5292",
    "data-name": "Group 5292",
    transform: "translate(2.05 2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9034",
    "data-name": "Path 9034",
    d: "M20.225,17.5l-.3-.9h0c0-.05-.35-1.05-.35-1h-.05c-.25-.5.05,0-7.35-7.45l.3-.3a.966.966,0,0,0,0-1.4l-.95-.95c-.85-.85-1.65.25-1.7.3L6.875,2.85a2.8,2.8,0,0,0-2-.85,2.72,2.72,0,0,0-2,.85,2.837,2.837,0,0,0,0,4L5.825,9.8c-.05.05-1.15.9-.3,1.7.8.7,1,1.25,1.65,1.25.55,0,.8-.45,1-.6l3.45,3.45h0l3.6,3.6c.5.5,1,.5,2.3,1,1,.85,1.4,1.8,2.6,1.8a1.9,1.9,0,0,0,1.35-3.25ZM3.575,6.15a1.872,1.872,0,0,1,0-2.6,1.811,1.811,0,0,1,2.6,0L9.125,6.5l-2.6,2.6Zm2.65,4.65.3-.3h0l4.3-4.3.95.95-.3.3h0l-4.3,4.3Zm2.65.7,2.6-2.6,6.75,6.75h-5.2Zm10.6,9.25-1.4-1.4c-3.1-1.1-1.1-.05-4.05-2.7h4.85l.5,1.45,1.4,1.4C21.625,20.3,20.325,21.6,19.475,20.75Z",
    transform: "translate(-2.05 -2)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9035",
    "data-name": "Path 9035",
    d: "M44.4,39.213a.52.52,0,0,0-.8,0c-.3.4-1.6,2.35-1.6,3.3a2,2,0,0,0,4,0C46,41.563,44.7,39.613,44.4,39.213Zm-1.4,3.3a6.147,6.147,0,0,1,1-2.1,6.147,6.147,0,0,1,1,2.1A1,1,0,0,1,43,42.513Z",
    transform: "translate(-22.025 -20.513)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnderDevelopment);
export default __webpack_public_path__ + "static/media/under-development.b2ce550e5ec94ad03e3264ce1636cc27.svg";
export { ForwardRef as ReactComponent };